import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { css } from '@styled-system/css';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var containedStyles = css(function (theme) {
  return {
    maxWidth: ["100%", theme.containers.xs, theme.containers.sm, theme.containers.ms, theme.containers.md, theme.containers.ml, theme.containers.lg, theme.containers.xl, theme.containers.xxl]
  };
});
var sizeVariants = variant({
  prop: "responsiveSize",
  variants: {
    fluid: {
      maxWidth: "100%"
    },
    contained: containedStyles,
    xs: {
      maxWidth: function maxWidth(_ref) {
        var theme = _ref.theme;
        return theme.containers.xs;
      }
    },
    sm: {
      maxWidth: function maxWidth(_ref2) {
        var theme = _ref2.theme;
        return theme.containers.sm;
      }
    },
    ms: {
      maxWidth: function maxWidth(_ref3) {
        var theme = _ref3.theme;
        return theme.containers.ms;
      }
    },
    md: {
      maxWidth: function maxWidth(_ref4) {
        var theme = _ref4.theme;
        return theme.containers.md;
      }
    },
    ml: {
      maxWidth: function maxWidth(_ref5) {
        var theme = _ref5.theme;
        return theme.containers.ml;
      }
    },
    lg: {
      maxWidth: function maxWidth(_ref6) {
        var theme = _ref6.theme;
        return theme.containers.lg;
      }
    },
    xl: {
      maxWidth: function maxWidth(_ref7) {
        var theme = _ref7.theme;
        return theme.containers.xl;
      }
    },
    xxl: {
      maxWidth: function maxWidth(_ref8) {
        var theme = _ref8.theme;
        return theme.containers.xxl;
      }
    }
  }
});
var StyledContainer = styled(Box).withConfig({
  componentId: "sc-1n875f9-0"
})(["margin-left:auto;margin-right:auto;width:100%;padding-left:", ";padding-right:", ";--maestro-container-padding:", ";", ";", ";", ";"], spacing("sm"), spacing("sm"), spacing("sm"), function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoint("ms", "up")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        padding-left: ", ";\n        padding-right: ", ";\n        --maestro-container-padding: ", ";\n    "])), spacing("lg"), spacing("lg"), spacing("lg"));
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoint("lg", "up")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        padding-left: ", ";\n        padding-right: ", ";\n        --maestro-container-padding: ", ";\n    "])), spacing("xl"), spacing("xl"), spacing("xl"));
}, sizeVariants);
var Container = forwardRef(function (props, ref) {
  var _a = props,
      _a$size = _a.size,
      size = _a$size === void 0 ? "xxl" : _a$size,
      rest = __objRest(_a, ["size"]);

  return (
    /* @__PURE__ */
    React.createElement(StyledContainer, __spreadValues({
      ref: ref,
      responsiveSize: size
    }, rest))
  );
});
Container.displayName = "Container";
export { Container };